interface IProp {
  text: string;
  onClick?: VoidFunction;
}

export const DropdownLabel = ({ text, onClick }: IProp) => (
  <a
    rel="noopener noreferrer"
    href="#"
    onClick={(e) => {
      e.preventDefault();

      onClick?.();
    }}
  >
    {text}
  </a>
);
